export const CLIENT = {
  name: "Sovan Gourav Rout",
  shortName: "Sovan Rout",
  role: "Live Sound Engineer & Audio Specialist",
  location: "Dubai, UAE & India",
  email: "sovan.rout274@gmail.com",
};

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Experience", href: "#experience" },
  { label: "Productions", href: "#productions" },
  { label: "Showreel", href: "#showreel" },
  { label: "Skills", href: "#skills" },
];

export const EXPERTISE = [
  "Live Sound, FOH & Monitor Engineering",
  "Audio System Design & Tuning",
  "Event & Stage Operations",
  "Console Operation",
  "Live Band & Solo Artist Mixing",
  "Dante Networking",
  "Line Arrays",
  "Technical Troubleshooting",
];

export const TIMELINE = [
  {
    role: "Audio Technician",
    company: "AgorA LLC",
    period: "Sep 2024 — Present",
    location: "Dubai, UAE",
    current: true,
    logo: "/images/agora-logo.webp",
    description:
      "Part of the stage & show operations team at Al Wasl Plaza, Expo City Dubai — handling show setup, equipment preparation, rack building, maintenance and technical support beneath one of the world's largest 360° projection domes.",
  },
  {
    role: "Freelance Live Sound Engineer",
    company: "Various Productions",
    period: "Jan 2023 — Present",
    location: "UAE & Region",
    current: true,
    description:
      "FOH, monitor and event audio engineering across concerts, festivals, corporate productions and conferences — from arena headline shows to multi-stage exhibitions. Open to tours, festival seasons and production residencies across India alongside UAE work.",
    productions: [
      "The Fridge Concert Series",
      "Shongololo Festival",
      "Arabian Travel Market",
      "GISEC 2024",
      "GITEX Global",
      "ADIPEC",
      "ITU RA & ITU WRC",
      "Arab Media Forum",
      "Tomorrowland — Amare Stage",
      "Saudi Business Conclave",
      "DEMI LOVATO — Coca-Cola Arena",
      "Atif Aslam with Firdaus Orchestra",
      "Moonlight Festival — Coca-Cola Arena",
      "Speed Music Fest — Coca-Cola Arena",
      "Ali Zafar Live",
      "AFROWORLD ft. Omah Lay & Rema",
      "Dimitri Vegas & Like Mike",
    ],
  },
  {
    role: "Live Sound Engineer",
    company: "PizzaExpress UAE",
    period: "Apr 2023 — Aug 2023",
    location: "Dubai, UAE",
    current: false,
    description:
      "Live music engineering for the venue's resident and guest artist programme — nightly mixes, stage management and system upkeep.",
  },
  {
    role: "Sound Technician",
    company: "Seven Stars Events",
    period: "Sep 2022 — Dec 2022",
    location: "Dubai, UAE",
    current: false,
    description:
      "Event audio technician across corporate and private productions — setup, rigging support, soundchecks and show operation.",
  },
  {
    role: "Sound Technician",
    company: "The Fridge",
    period: "Sep 2022 — Oct 2022",
    location: "Dubai, UAE",
    current: false,
    description:
      "Technician for one of Dubai's longest-running live music venues and its concert series — backline, patching and show support.",
  },
];

export const FILTERS = ["All", "Concerts", "Festivals", "Corporate", "Conferences"];

export const PRODUCTIONS = [
  {
    title: "DEMI LOVATO — Live in Dubai",
    category: "Concerts",
    venue: "Coca-Cola Arena, Dubai",
    role: "Live Sound Engineer",
    production: "Freelance Event Production",
    image: "/images/console-work.jpeg",
    description:
      "Arena-scale pop production — event audio engineering and large-format console operation for an international headline act.",
  },
  {
    title: "Al Wasl Plaza — Live Shows",
    category: "Corporate",
    venue: "Expo City Dubai",
    role: "Audio Technician",
    production: "AgorA LLC",
    image: "/images/hero-concert.webp",
    description:
      "Concerts and ceremonies under the iconic trellis dome — show setup, rack building and technical support for daily productions.",
  },
  {
    title: "Atif Aslam with Firdaus Orchestra",
    category: "Concerts",
    venue: "Dubai, UAE",
    role: "Live Sound Engineer",
    production: "Freelance Event Production",
    image: "/images/alwasl-dome-show.jpeg",
    description:
      "A full orchestra backing one of South Asia's biggest voices — complex stage plots, high channel counts and precision mixing.",
  },
  {
    title: "Moonlight Festival",
    category: "Festivals",
    venue: "Coca-Cola Arena, Dubai",
    role: "Live Sound Engineer",
    production: "Freelance Event Production",
    image: "/images/festival-stage-night.webp",
    description:
      "Multi-artist festival night at the region's premier indoor arena — rapid changeovers and consistent sound across every act.",
  },
  {
    title: "GITEX Global",
    category: "Corporate",
    venue: "Dubai World Trade Centre",
    role: "Live Sound Engineer",
    production: "Freelance Event Production",
    image: "/images/gitex-real.jpg",
    description:
      "One of the world's largest tech exhibitions — event audio across stages, activations and headline product launches.",
  },
  {
    title: "GISEC 2024",
    category: "Conferences",
    venue: "Dubai World Trade Centre",
    role: "Live Sound Engineer",
    production: "Freelance Event Production",
    image: "/images/gisec-conference.jpg",
    description:
      "The region's leading cybersecurity conference — speech reinforcement and session audio across concurrent conference halls.",
  },
];

export const SKILL_GROUPS = [
  {
    title: "Live Sound",
    icon: "Mic",
    items: ["FOH Engineering", "Monitor Engineering", "Live Band Mixing", "Stage Operations", "Event Audio"],
  },
  {
    title: "Audio Systems",
    icon: "Speaker",
    items: ["System Design", "System Tuning", "Line Arrays", "Signal Flow", "Audio Networking"],
  },
  {
    title: "Consoles",
    icon: "Sliders",
    groups: [
      { brand: "Allen & Heath", models: ["ML3000", "QU Series", "SQ Series", "Avantis", "dLive Series"] },
      { brand: "Midas", models: ["Pro X", "M32"] },
      { brand: "Yamaha", models: ["M7CL", "QL Series", "CL Series", "TF Series", "Analog"] },
      { brand: "DiGiCo", models: ["S Series", "SD Series", "Quantum Series"] },
    ],
  },
  {
    title: "Technology",
    icon: "Network",
    items: ["Dante", "Shure Wireless Workbench", "Pro Tools"],
  },
  {
    title: "Systems",
    icon: "Radio",
    items: ["d&b audiotechnik", "L'Acoustics", "Electro-Voice", "DAS Audio", "Meyer Sound", "RCF"],
  },
];

export const SHOWREEL = [
  {
    src: "/videos/vdo6.mp4",
    poster: "/videos/vdo6-poster.jpg",
    title: "Show night",
    caption: "Live performance — Al Wasl Plaza, Expo City Dubai",
  },
  {
    src: "/videos/vdo1.mp4",
    poster: "/videos/vdo1-poster.jpg",
    title: "Orchestra under the dome",
    caption: "Orchestral show with 360° projection — Al Wasl Plaza",
  },
  {
    src: "/videos/vdo3.mp4",
    poster: "/videos/vdo3-poster.jpg",
    title: "The view from FOH",
    caption: "Show control position — Al Wasl Plaza, Expo City Dubai",
  },
  {
    src: "/videos/vdo2.mp4",
    poster: "/videos/vdo2-poster.jpg",
    title: "Festival main stage",
    caption: "Line arrays flown, full band live — outdoor festival, Dubai",
  },
  {
    src: "/videos/vdo4.mp4",
    poster: "/videos/vdo4-poster.jpg",
    title: "Orchestra close-up",
    caption: "Strings & traditional instruments — Al Wasl Plaza",
  },
  {
    src: "/videos/showreel-badshah.mp4",
    poster: "/videos/showreel-badshah-poster.jpg",
    title: "Badshah — Skyline Show",
    caption: "Open-air headline set against the Dubai skyline",
  },
  {
    src: "/videos/showreel-indian.mp4",
    poster: "/videos/showreel-indian-poster.jpg",
    title: "Jonita — Live in Concert",
    caption: "Arena production — full band, dancers & flown line arrays",
  },
  {
    src: "/videos/showreel-djnight.mp4",
    poster: "/videos/showreel-djnight-poster.jpg",
    title: "Skyline DJ Night",
    caption: "Open-air electronic set — Dubai Marina after dark",
  },
  {
    src: "/videos/showreel-soundcheck.mp4",
    poster: "/videos/showreel-soundcheck-poster.jpg",
    title: "The Fridge Sessions",
    caption: "Intimate live session — The Fridge Concert Series, Dubai",
  },
];

export const FIELD_PHOTOS = [
  {
    image: "/images/console-sd7-dome.webp",
    caption: "DiGiCo SD7 at FOH — under the Al Wasl Plaza dome, Expo City Dubai",
  },
  {
    image: "/images/foh-expo-city.webp",
    caption: "Dual DiGiCo FOH position — Expo City Dubai",
  },
  {
    image: "/images/rf-prep-shure.webp",
    caption: "Wireless RF coordination — instrument-tagged prep for orchestra shows",
  },
  {
    image: "/images/digico-blue-room.webp",
    caption: "Control room — DiGiCo SD & Quantum racks, show programming",
  },
  {
    image: "/images/field-foh-moonlight.jpeg",
    caption: "Minutes to doors — DiGiCo armed at FOH, Moonlight Music Festival, Coca-Cola Arena",
  },
  {
    image: "/images/field-jonita.jpeg",
    caption: "Artist liaison done right — pre-show with Jonita Gandhi",
  },
  {
    image: "/images/field-team.jpeg",
    caption: "The crew that makes it look easy — comms on, showtime ready",
  },
  {
    image: "/images/field-mentor.jpeg",
    caption: "Always learning — deep in the pro audio world with mentors & friends",
  },
];

export const CREDENTIALS = [
  {
    name: "Dante Level 1 — 2nd Edition",
    issuer: "Audinate",
    detail: "Certified Oct 2025",
    kind: "certification",
  },
  {
    name: "Drive System",
    issuer: "L-Acoustics",
    detail: "Certified Oct 2025",
    kind: "certification",
  },
  {
    name: "Audio Engineering Certification",
    issuer: "Skill Tech Audio Engineering Institute",
    detail: "2022 · Grade A",
    kind: "certification",
  },
  {
    name: "BBA — Human Resources Management",
    issuer: "ASBM University",
    detail: "2016 – 2019 · Grade 8.2",
    kind: "education",
  },
];

export const TESTIMONIAL = {
  paragraphs: [
    "I had the pleasure of guiding Sovan at Skill Tech Audio Engineering, where he graduated in 2022. From day one, he stood out as one of the most dedicated, reliable, and capable students I've worked with.",
    "Sovan consistently demonstrated a deep understanding of professional audio engineering, with an outstanding work ethic and sharp technical instincts. Beyond his skills, what truly sets him apart is his temperament — calm under pressure, collaborative, and always dependable. Sovan brings professionalism and a positive attitude.",
    "It's been incredibly rewarding to watch his journey as he's grown into a high-level professional in the field. Without hesitation I recommend Sovan!",
  ],
  author: "Andy James Ward",
  title: "Founder, Skill Tech Audio",
};
